import React, { useState, useEffect } from "react";
import AutomationEditCardContent from "../../automation/automation-edit-card-content";

const DefaultAutomationDetail1Widget = ({ widget, onStatusChange }) => {
  const [automationParams, setAutomationParams] = useState(null);

  useEffect(() => {
    // Extract automation parameters from widget
    if (widget && widget.id) {
      console.log("widget", widget);
      // Transform widget ID from format "XXX|uuid" to "P-uuid" for automationId
      const baseAutomationId = widget.id.includes("|")
        ? `${widget.id.split("|")[1]}`
        : `${widget.id}`;
      const transformedAutomationId = widget.id.startsWith("Q-")
        ? `S-${baseAutomationId}`
        : `P-${baseAutomationId}`;

      setAutomationParams({
        automationId: transformedAutomationId,
        category: "TWIN",
        embed: true,
      });
    }
  }, [widget]);

  return (
    <div className="w-full">
      <AutomationEditCardContent
        params={automationParams}
        onSave={onStatusChange}
        onDelete={() => {}}
        editable={true}
        onEnableDisable={onStatusChange}
      />
    </div>
  );
};

export default DefaultAutomationDetail1Widget;
